import { connect, useSelector } from 'react-redux';
import { passwordReminder } from '../../../../redux/userActions';
import { Button } from '../../../../../../common/components';
import React from 'react';
import getIncludedResource from '../../../../../../helpers/getIncludedResource';

const ResetButton = ({ onPasswordReminder, email, channel }) => {
  const { isResetting } = useSelector((state) => state?.user);

  const { url: channelUrl, key: channelKey, name } = channel?.attributes ?? {};
  const sendResetPassword = () => {
    const values = {
      email: email,
    };
    const url = channelUrl ? new URL(channelUrl) : '';
    if (url) {
      values['requestItems'] = {
        channel: channelKey,
      };
      values['scheme'] = url.protocol?.replace(':', '');
      values['host'] = url.host;
    }
    return onPasswordReminder(values);
  };

  return (
    <Button
      className="pull-right"
      bsStyle="primary"
      rightIcon="envelope"
      isLoading={isResetting}
      handleClick={sendResetPassword}
      label={`Send ${name} Password Reset Email`}
    />
  );
};

const ResetPasswordButton = ({ resource, onPasswordReminder }) => {
  const currentOrganisation = getIncludedResource(
    resource.data,
    resource.included,
    'current_organisation',
  );

  const channelAccessForCurrentOrganisation = getIncludedResource(
    currentOrganisation.data,
    resource.included,
    'channel_access',
  );

  const sendPasswordResetEmail = (values) => {
    return onPasswordReminder(values);
  };

  return (
    <>
      {Array.isArray(channelAccessForCurrentOrganisation) &&
        channelAccessForCurrentOrganisation?.map((channel) => {
          return (
            <ResetButton
              channel={channel}
              onPasswordReminder={sendPasswordResetEmail}
              email={resource?.data?.attributes?.email}
            />
          );
        })}
    </>
  );
};

export default connect(
  null,
  {
    onPasswordReminder: passwordReminder,
  },
)(ResetPasswordButton);
